module.exports = __webpack_public_path__ + "img/Livre_d_or_de_mariage.443acaf.jpg";